import { render } from "./generic-form.vue?vue&type=template&id=60def4f6"
import script from "./generic-form.vue?vue&type=script&lang=js"
export * from "./generic-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__